import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';
import { GlobalProvider } from 'commons';
import store from './state/configureStore';
import './scss/index.scss';
import App from './containers/app';

let gaAccount = '';
const locationHost = window.location.host;
switch (locationHost) {
  case 'member-qa1.everbridge.net':
    gaAccount = 'UA-128700331-2';
    break;
  case 'member-qa2.everbridge.net':
    gaAccount = 'UA-128700331-3';
    break;
  case 'member-stage.everbridge.net':
    gaAccount = 'UA-128700331-4';
    break;
  case 'member.everbridge.net':
    gaAccount = 'UA-128700331-1';
    break;
  default:
    gaAccount = 'UA-128396362-4';
}
ReactGA.initialize(gaAccount);

ReactDOM.render(
  <GlobalProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </GlobalProvider>,
  document.getElementById('root'),
);
